<template>
    <div class="analytics-num-practice-mode">
        <span class="analytics-num-practice-mode__art"></span>
        <div class="analytics-num-practice-mode__total">
            <div class="analytics-num-practice-mode__wr-total">
                <span class="analytics-num-practice-mode__total-icon"></span>
                <div class="analytics-num-practice-mode__wr-total-content">
                    <div
                        v-if="showPreloader"
                        class="analytics-num-practice-mode__total-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-num-practice-mode__wr-total-value">
                            <span class="analytics-num-practice-mode__total-value">{{ filteredNumPracticeModeData.total }}</span>
                            <span class="analytics-num-practice-mode__total-unit">PRATİK</span>
                        </span>
                        <span class="analytics-num-practice-mode__total-label">toplam</span>
                    </template>
                </div>
            </div>
        </div>

        <div class="analytics-num-practice-mode__wr-modes">
            <div class="analytics-num-practice-mode__phonemic-vowel">
                <div class="analytics-num-practice-mode__wr-phonemic-vowel">
                    <div
                        v-if="showPreloader"
                        class="analytics-num-practice-mode__phonemic-vowel-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-num-practice-mode__phonemic-vowel-value">{{ filteredNumPracticeModeData.phonemicVowel }}</span>
                        <span class="analytics-num-practice-mode__phonemic-vowel-unit">PRATİK</span>
                        <span class="analytics-num-practice-mode__phonemic-vowel-label">ünlü özellikleri</span>
                    </template>
                    <span class="analytics-num-practice-mode__phonemic-vowel-icon"></span>
                </div>
            </div>
            <div class="analytics-num-practice-mode__phonemic-consonant">
                <div class="analytics-num-practice-mode__wr-phonemic-consonant">
                    <div
                        v-if="showPreloader"
                        class="analytics-num-practice-mode__phonemic-consonant-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-num-practice-mode__phonemic-consonant-value">{{ filteredNumPracticeModeData.phonemicConsonant }}</span>
                        <span class="analytics-num-practice-mode__phonemic-consonant-unit">PRATİK</span>
                        <span class="analytics-num-practice-mode__phonemic-consonant-label">ünsüz özellikleri</span>
                    </template>
                    <span class="analytics-num-practice-mode__phonemic-consonant-icon"></span>
                </div>
            </div>
            <div class="analytics-num-practice-mode__phonetic-vowel">
                <div class="analytics-num-practice-mode__wr-phonetic-vowel">
                    <div
                        v-if="showPreloader"
                        class="analytics-num-practice-mode__phonetic-vowel-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-num-practice-mode__phonetic-vowel-value">{{ filteredNumPracticeModeData.phoneticVowel }}</span>
                        <span class="analytics-num-practice-mode__phonetic-vowel-unit">PRATİK</span>
                        <span class="analytics-num-practice-mode__phonetic-vowel-label">ünlü değişkeleri</span>
                    </template>
                    <span class="analytics-num-practice-mode__phonetic-vowel-icon"></span>
                </div>
            </div>
            <div class="analytics-num-practice-mode__phonetic-consonant">
                <div class="analytics-num-practice-mode__wr-phonetic-consonant">
                    <div
                        v-if="showPreloader"
                        class="analytics-num-practice-mode__phonetic-consonant-preloader"></div>
                    <template v-if="!showPreloader">
                        <span class="analytics-num-practice-mode__phonetic-consonant-value">{{ filteredNumPracticeModeData.phoneticConsonant }}</span>
                        <span class="analytics-num-practice-mode__phonetic-consonant-unit">PRATİK</span>
                        <span class="analytics-num-practice-mode__phonetic-consonant-label">ünsüz değişkeleri</span>
                    </template>
                    <span class="analytics-num-practice-mode__phonetic-consonant-icon"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            filteredNumPracticeModeData(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.numPracticeMode.type;
                return this.$store.state.response.analyticsPractice.numPracticeModeData[selectedFiltertagType];
            },
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsNumPracticeMode)
                .then(response => response.json())
                .then(numPracticeModeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'numPracticeModeData',
                        data: numPracticeModeData
                    });
                    this.showPreloader = false;
                })
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsPracticeNumPracticeMode, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(numPracticeModeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'numPracticeModeData',
                        data: numPracticeModeData
                    });
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.$foneturkError({
                        'text': 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-num-practice-mode.css"></style>